import isEqual from 'lodash/isEqual';
import { atom, selector } from 'recoil';

import {
  MYSCRIBE_CHAT_SCOPES,
  myScribeInputTagsState
} from 'components/practice/charts/ClinicalNote/MyScribeAI/state';
import { withoutUnsavedEmptyRows } from 'components/practice/charts/ClinicalNote/CurrentNote/TypeNotes/MyScribeAI/lib/helpers';

export const isAmbientListeningActive = atom({
  key: 'isAmbientListeningActive',
  default: false
});

export const ambientRecordingTime = atom({
  key: 'ambientRecordingTime',
  default: 0
});

export const enhanceAmbientListeningLoading = atom({
  key: 'enhanceAmbientListeningLoading',
  default: false
});

export const ambientListeningIntelligenceChatId = atom({
  key: 'ambientListeningIntelligenceChatId',
  default: null
});

export const enhancedNote = atom({
  key: 'enhancedNote',
  default: null
});

export const ambientListeningMessages = atom({
  key: 'ambientListeningMessages',
  default: []
});

export const ambientThreadHydrating = atom({
  key: 'ambientThreadHydrating',
  default: false
});

export const ambientListeningRegenerateTargetId = atom({
  key: 'ambientListeningRegenerateTargetId',
  default: null
});

export const isAmbientNoteEdited = atom({
  key: 'isAmbientNoteEdited',
  default: false
});

export const ambientListeningStreamingText = atom({
  key: 'ambientListeningStreamingText',
  default: null
});

export const emCPTsText = atom({
  key: 'emCPTsText',
  default: null
});

// True after an abort that produced nothing; cleared when a new generation starts.
export const ambientListeningStopped = atom({
  key: 'ambientListeningStopped',
  default: false
});

export const currentActiveStepID = atom({
  key: 'currentActiveStepID',
  default: null
});

export const transcriptionLoading = atom({
  key: 'transcriptionLoading',
  default: false
});

export const isTranscriptionCreated = atom({
  key: 'isTranscriptionCreated',
  default: null
});

export const transcriptions = atom({
  key: 'transcriptions',
  default: []
});

export const selectedNoteType = atom({
  key: 'selectedAmbientListeningNoteType',
  default: null
});

export const preSelectedNoteType = atom({
  key: 'preSelectedAmbientListeningNoteType',
  default: null
});

export const additionalProviderNotesState = atom({
  key: 'additionalProviderNotesState',
  default: ''
});

export const transcriptEditingRowIdState = atom({
  key: 'transcriptEditingRowIdState',
  default: null
});

export const transcriptEditAllConversationsState = atom({
  key: 'transcriptEditAllConversationsState',
  default: false
});

export const transcriptStaticState = atom({
  key: 'transcriptStaticState',
  default: []
});

export const ambientListeningNoteTitle = atom({
  key: 'ambientListeningNoteTitle',
  default: ''
});

export const isTranscriptContentDirtyState = selector({
  key: 'isTranscriptContentDirtyState',
  get: ({ get }) =>
    !isEqual(
      withoutUnsavedEmptyRows(get(transcriptions)),
      withoutUnsavedEmptyRows(get(transcriptStaticState))
    )
});

export const ambientAttachedFilesState = atom({
  key: 'ambientAttachedFilesState',
  default: [],
  dangerouslyAllowMutability: true
});

export const ambientRefineFilesState = atom({
  key: 'ambientRefineFilesState',
  default: [],
  dangerouslyAllowMutability: true
});

export const ambientListeningHasChipsState = selector({
  key: 'ambientListeningHasChipsState',
  get: ({ get }) =>
    get(ambientAttachedFilesState).length > 0 ||
    get(ambientRefineFilesState).length > 0 ||
    get(myScribeInputTagsState(MYSCRIBE_CHAT_SCOPES.ambient)).length > 0 ||
    get(myScribeInputTagsState(MYSCRIBE_CHAT_SCOPES.ambientRefine)).length > 0
});

export const isAmbientNoteEditingState = atom({
  key: 'isAmbientNoteEditingState',
  default: false
});

export const ambientListeningRefineTextState = atom({
  key: 'ambientListeningRefineTextState',
  default: ''
});

export const hasPendingComposerTextState = selector({
  key: 'hasPendingComposerTextState',
  get: ({ get }) =>
    !!(get(additionalProviderNotesState) || '').trim() ||
    !!get(ambientListeningRefineTextState).trim()
});
